// v-reveal: marks an element data-reveal="out" on mount and flips it to "in"
// once it scrolls into view; each component styles the two states itself.
// SSR output carries no attribute, so content stays visible without JS.
type RevealEl = HTMLElement & { _revealIo?: IntersectionObserver };

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('reveal', {
    getSSRProps: () => ({}),
    mounted(el: RevealEl) {
      if (!('IntersectionObserver' in window)) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      el.dataset.reveal = 'out';
      el._revealIo = new IntersectionObserver(
        ([entry]) => {
          if (!entry.isIntersecting) return;
          el.dataset.reveal = 'in';
          el._revealIo?.disconnect();
        },
        { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
      );
      el._revealIo.observe(el);
    },
    unmounted(el: RevealEl) {
      el._revealIo?.disconnect();
    },
  });
});
